import { ReactNode } from 'react';

import { ApplePayIcon, BusinessIcon, CardIcon } from '@/shared/assets';
import { COLORS, cn } from '@/shared/lib';

import { NativePaymentMethods } from '../model/types';

const ApplePayItemIcon = ({ className }: { className?: string }) => {
  return (
    <img
      className={cn('min-h-10 max-w-10', className)}
      src={ApplePayIcon}
      alt="apple pay"
    />
  );
};
const PaymentMethodIconWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <div className="flex min-h-10 min-w-10 items-center justify-center rounded-full bg-surface-03">
      {children}
    </div>
  );
};
export const nativePaymentItemsTriggerInfo: NativePaymentMethods = {
  'apple-pay': {
    title: 'Apple Pay',
    description: '1-3 working days',
    icon: <ApplePayItemIcon className="min-h-6 max-w-6" />,
  },
  card: {
    title: 'Debit or credit card',
    description: '1-3 working days',
    icon: <CardIcon color={COLORS['icon-base-500']} />,
  },
  bank: {
    title: 'Bank transfer',
    description: '1-3 working days',
    icon: <BusinessIcon />,
  },
  swift: {
    title: 'SWIFT transfer',
    description: '1-3 working days',
    icon: <BusinessIcon />,
  },
};
export const nativeAddPaymentItems: Omit<NativePaymentMethods, 'swift'> = {
  bank: {
    title: 'Bank transfer',
    description: '1-3 working days. Send from your bank account abroad',
    icon: (
      <PaymentMethodIconWrapper>
        <BusinessIcon />
      </PaymentMethodIconWrapper>
    ),
  },
  'apple-pay': {
    title: 'Apple Pay',
    description: '1-3 working days',
    icon: <ApplePayItemIcon className="min-h-6" />,
    isSoon: true,
  },
  card: {
    title: 'Debit or credit card',
    description: '1-3 working days',
    icon: (
      <PaymentMethodIconWrapper>
        <CardIcon color={COLORS['icon-base-500']} />
      </PaymentMethodIconWrapper>
    ),
    isSoon: true,
  },
};
export const nativeSendBusinessItems: NativePaymentMethods = {
  ...nativeAddPaymentItems,
  swift: {
    title: 'SWIFT transfer',
    description: '1-3 working days. Send from your bank account abroad',
    icon: (
      <PaymentMethodIconWrapper>
        <BusinessIcon />
      </PaymentMethodIconWrapper>
    ),
  },
};
